import { WinningLinesCoordinate20 } from '../../gameConstants';

export const handleSymbolAnimationPositionInMatrix = (winsMatrix) => {
  const winLines = [];
  let winLine = {};
  const allLinesMatrix = [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ];
  winsMatrix.forEach((el) => {
    const activeSymbolsMatrix = [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ];
    let winElCount = 0;
    const isFromRight = el.line > 20;
    const lineIndex = el.line - (isFromRight ? 21 : 1);
    for (let i = isFromRight ? 4 : 0; isFromRight ? i >= 0 : i < 5; i += isFromRight ? -1 : 1) {
      const line = WinningLinesCoordinate20[lineIndex][i];
      const row = line.x;
      const coll = line.y;
      if (winElCount < el.count) {
        winElCount += 1;
        activeSymbolsMatrix[row][coll] = 1;
        allLinesMatrix[row][coll] = 1;
      } else {
        activeSymbolsMatrix[row][coll] = 2;
        allLinesMatrix[row][coll] = allLinesMatrix[row][coll] ? allLinesMatrix[row][coll] : 2;
      }
    }

    winLine = {
      count: el.count,
      lines: activeSymbolsMatrix,
      allLines: allLinesMatrix,
      win: el.lineWinAmount,
      winCard: el.symbol,
      line: el.line,
    };
    winLines.push(winLine);
  });

  return winLines;
};
